// Utils
import { escapeStringRegexp } from 'ezyvet-fe-helpers';
// Types
import { objectReferencePrefix } from './constants';
/**
 * Constructs and returns a regular expression to match object id encoding
 *
 * @return {RegExp}
 */
export default function getObjectIdRegex() {
    return new RegExp("^" + escapeStringRegexp(objectReferencePrefix));
}
//# sourceMappingURL=getObjectIdRegex.js.map